import { Modal, Form, Button } from 'antd';
import { PackagingForm } from './PackagingFormV2';
import { useStoreActions, useStoreState } from '../../store';
import { createUseStyles } from 'react-jss';
import type { PartnerPackagingV2 } from '../../store/services/PartnerService/types';
import { buildPackagingRequestBody } from '../../pages/AdminPages/ConfigurationAssets/Packaging/manage/packagingRequestBody';

const useStyles = createUseStyles({
  modal: {},
  formContainer: {
    margin: '30px 15px 30px 15px',
  },
  avatar: {
    marginLeft: '40%',
    background: '#000',
  },
});

export const MODAL_KEY = 'packagingModalV2';

export const PackagingModal = () => {
  const open = useStoreState((state) => state.navigation.modals[MODAL_KEY]?.open);
  const activePartnerPackaging = useStoreState(
    (state) => state.navigation.modals[MODAL_KEY]?.params as PartnerPackagingV2,
  );
  const closeModal = useStoreActions((actions) => actions.navigation.toggleModal);
  const createPartnerPackaging = useStoreActions((action) => action.packagingV2.createPartnerPackagingV2);
  const updatePartnerPackaging = useStoreActions((action) => action.packagingV2.updatePartnerPackagingV2);

  const classes = useStyles();
  const [form] = Form.useForm();

  const handleCancelClick = () => {
    form.resetFields();
    closeModal({ key: MODAL_KEY, open: false, params: undefined });
  };

  const handleSubmit = (event: any) => {
    form.validateFields().then(() => {
      const values = form.getFieldsValue();
      const packaging: PartnerPackagingV2 = {
        ...buildPackagingRequestBody(values),
        packagingId: activePartnerPackaging?.packagingId,
      };
      if (!activePartnerPackaging) {
        createPartnerPackaging(packaging);
      } else {
        updatePartnerPackaging(packaging);
      }
      form.resetFields();
      closeModal({ key: MODAL_KEY, open: false, params: undefined });
    });
  };

  const footer = [
    <Button key={'cancel'} onClick={handleCancelClick}>
      Cancel
    </Button>,
    <Button key={'submit'} type="primary" onClick={handleSubmit}>
      Submit
    </Button>,
  ];

  return (
    <Modal
      title={'Create Packaging'}
      className={classes.modal}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancelClick}
      footer={footer}
    >
      <PackagingForm form={form} activePartnerPackaging={activePartnerPackaging} wrapperCol={{ span: 20, offset: 1 }} />
    </Modal>
  );
};
